export type ComparedSystemIdentity = {
  id: string;
  uniqueId: string;
};

export const removalKeysForSystem = (
  systemId: string,
  compared: ComparedSystemIdentity | undefined
): string[] => {
  const keys = [systemId, compared?.id, compared?.uniqueId].filter(
    (key): key is string => Boolean(key)
  );
  return keys.filter((key, index) => keys.indexOf(key) === index);
};

export const withoutComparisonRemovedSystems = <
  T extends { uniqueId?: string }
>(
  systems: T[],
  removedUniqueIds: readonly string[] | undefined
): T[] => {
  const removed = removedUniqueIds ?? [];
  if (removed.length === 0) return systems;
  const removedSet = new Set(removed);
  return systems.filter(
    (system) => system.uniqueId == null || !removedSet.has(system.uniqueId)
  );
};
